// extracted by mini-css-extract-plugin
export default {"dataExplorePageContent":"PageContent_dataExplorePageContent__gWHy5","title":"PageContent_title__tFxmB"};